import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var REQUIRED_FIELD_SYMBOL = '*';
/** The `TitleField` is the template to use to render the title of a field
 *
 * @param props - The `TitleFieldProps` for this component
 */

export default function TitleField(props) {
  var id = props.id,
      title = props.title,
      required = props.required;
  return _jsxs("legend", {
    id: id,
    children: [title, required && _jsx("span", {
      className: 'required',
      children: REQUIRED_FIELD_SYMBOL
    })]
  });
}